import React from "react";
import { Plus, Trash2, Edit } from "lucide-react";

interface DistrictItemProps {
  district: {
    id: string;
    name: string;
    user_id: string;
    created_at: string;
    course_type?: string;
  };
  stateName: string;
  creatorName: string;
  schoolsCount: number;
  adminsCount: number;
  onDelete: (district: {
    id: string;
    name: string;
    user_id: string;
    created_at: string;
  }) => void;
  onEdit: (district: {
    id: string;
    name: string;
    user_id: string;
    created_at: string;
  }) => void;
  onAddSchool: (district: any) => void;
  onAddAdmin: (district: any) => void;
}

export function DistrictItem({
  district,
  stateName,
  creatorName,
  schoolsCount,
  adminsCount,
  onDelete,
  onEdit,
  onAddSchool,
  onAddAdmin,
}: DistrictItemProps) {
  return (
    <tr key={district.id}>
      <td className="px-6 py-4">
        <div className="text-sm font-medium text-gray-900">{district.name}</div>
      </td>
      <td className="px-6 py-4">
        <div className="text-sm text-gray-500">
          {stateName} {district.course_type ? `(${district.course_type})` : ""}
        </div>
      </td>
      <td className="px-6 py-4">
        <div className="text-sm text-gray-500">{creatorName}</div>
      </td>
      <td className="px-6 py-4">
        <div className="text-sm text-gray-500">
          {new Date(district.created_at).toLocaleDateString()}
        </div>
      </td>
      <td className="px-6 py-4">
        <div className="flex items-center space-x-2">
          <span className="text-sm text-gray-900">{schoolsCount}</span>
          <button
            onClick={() => onAddSchool(district)}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            title="Add School"
          >
            <Plus className="h-4 w-4" />
          </button>
        </div>
      </td>
      <td className="px-6 py-4">
        <div className="flex items-center space-x-2">
          <span className="text-sm text-gray-900">{adminsCount}</span>
          <button
            onClick={() => onAddAdmin(district)}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            title="Add Admin"
          >
            <Plus className="h-4 w-4" />
          </button>
        </div>
      </td>
      <td className="px-6 py-4">
        <div className="flex items-center space-x-2">
          <button
            onClick={() => onEdit(district)}
            className="text-blue-400 hover:text-blue-600 transition-colors"
            title="Edit District"
          >
            <Edit className="h-5 w-5" />
          </button>
          <button
            onClick={() => onDelete(district)}
            className="text-red-400 hover:text-red-600 transition-colors"
            title="Delete District"
          >
            <Trash2 className="h-5 w-5" />
          </button>
        </div>
      </td>
    </tr>
  );
}
